import { render, staticRenderFns } from "./ProDetails.vue?vue&type=template&id=c11e8a46&scoped=true&"
import script from "./ProDetails.vue?vue&type=script&lang=js&"
export * from "./ProDetails.vue?vue&type=script&lang=js&"
import style0 from "./ProDetails.vue?vue&type=style&index=0&id=c11e8a46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c11e8a46",
  null
  
)

export default component.exports